import { atom } from 'recoil';
import { PatientInteractionList } from '@/common/types';

export const interactionsState = atom<PatientInteractionList>({
    key: 'interactionsState',
    default: [],
});
